import { render, staticRenderFns } from "./AttentionCheck.vue?vue&type=template&id=73d42c2b&scoped=true&"
import script from "./AttentionCheck.vue?vue&type=script&lang=js&"
export * from "./AttentionCheck.vue?vue&type=script&lang=js&"
import style0 from "./AttentionCheck.vue?vue&type=style&index=0&id=73d42c2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d42c2b",
  null
  
)

export default component.exports